import {
  type StoreExtensionContext,
  StoreExtensionProvider,
} from '@blocksuite/affine-ext-loader';

import {
  AppBlockSchemaExtension,
  AppResourceBlockSchemaExtension,
  AppScreenBlockSchemaExtension,
  AutomationBlockSchemaExtension,
  BrushHeadingBlockSchemaExtension,
  ElsterBlockSchemaExtension,
  GhostBlockSchemaExtension,
  StickyNoteBlockSchemaExtension,
  TrashcanBlockSchemaExtension,
  TutorialCardBlockSchemaExtension,
  WorkflowStepBlockSchemaExtension,
} from './schemas/index.js';

/**
 * StreamLain Store Extension
 *
 * Registers all StreamLain block schemas with the BlockSuite store.
 * New blocks should add their schema extension here.
 */
export class StreamLainStoreExtension extends StoreExtensionProvider {
  override name = 'affine-streamlain-block';

  override setup(context: StoreExtensionContext) {
    super.setup(context);

    // Register StreamLain block schemas
    context.register(AppBlockSchemaExtension);
    context.register(AppScreenBlockSchemaExtension);
    context.register(AppResourceBlockSchemaExtension);
    context.register(AutomationBlockSchemaExtension);
    context.register(BrushHeadingBlockSchemaExtension);
    context.register(ElsterBlockSchemaExtension);
    context.register(GhostBlockSchemaExtension);
    context.register(StickyNoteBlockSchemaExtension);
    context.register(TrashcanBlockSchemaExtension);
    context.register(TutorialCardBlockSchemaExtension);
    context.register(WorkflowStepBlockSchemaExtension);
  }
}
